import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { coverageService } from '../Services/CoverageService';

const AddressComponent = React.memo(({ addressData: personalDetail, onChange }) => {
  const [localAddress, setLocalAddress] = useState(personalDetail);
  const [stateOrProvince, setStateOrProvince] = useState([]);
  const stateOrProvinceLabel = personalDetail.countryCd === 'CAN' ? 'Province, Postal Code' : 'State, Zip';

  useEffect(() => {
    const fetchStateOrProvinces = async () => {
      try {
        const stateOrProviceResponse = await coverageService.getStateOrProvinceByStAbbr(personalDetail.countryCd);
        setStateOrProvince(stateOrProviceResponse);
      } catch (err) {
        console.error('Failed to fetch coverage with id' + err.message);
      }
    };
    fetchStateOrProvinces();
  }, [personalDetail]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setLocalAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));
    onChange(getDataAttrName(name), value);
  };

  const getDataAttrName = (name) => {
    switch (name) {
      case 'addressLine':
        return 'addrLine1Tx';
      case 'stateOrProvCodes':
        return 'stAbbrCd';
      case 'city':
        return 'cityNm';
      case 'secondaryEmail':
        return 'scndryEmailAddrTx';
      case 'email':
        return 'emailAddrTx';
      case 'stateOrZip':
        return 'zipCd';
      default:
        return '';
    }
  };

  return (
    <>
      <tr>
        <td>
          <label htmlFor="addressLine">Address:</label>
        </td>
        <td>
          <input
            type="text"
            id="addressLine"
            name="addressLine"
            className="fmc-input"
            data-testid="addressLineTestId"
            value={localAddress.addressLine}
            onChange={handleFieldChange}
          />
        </td>
      </tr>

      <tr>
        <td>
          <label htmlFor="addressCity">City:</label>
        </td>
        <td>
          <input
            type="text"
            id="addressCity"
            name="city"
            className="fmc-input"
            value={localAddress.city || ''}
            onChange={handleFieldChange}
          />
        </td>
      </tr>

      <tr>
        <td>
          <label htmlFor="stateOrProvCodes">{stateOrProvinceLabel}:</label>
        </td>
        <td>
          <table>
            <thead>
              <tr style={{ display: 'none'}}>
                <th scope="col">State/Province</th>
                <th scope="col">Zip</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: 'none', paddingLeft: '0rem' }}>
                  <select
                    id="stateOrProvCodes"
                    name="stateOrProvCodes"
                    size="1"
                    className="fmc-select"
                    value={localAddress.stateOrProvCodes}
                    onChange={handleFieldChange}
                  >
                    {stateOrProvince.map((sp) => (
                      <option value={sp.stAbbrCd} key={sp.stAbbrCd}>
                        {sp.stAbbrCd}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={{ border: 'none' }}>
                  <input
                    type="text"
                    name="stateOrZip"
                    className="fmc-input"
                    value={localAddress.stateOrZip || ''}
                    onChange={handleFieldChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="primaryEmail">Primary Email:</label>
        </td>
        <td>
          <input
            type="email"
            id="primaryEmail"
            name="email"
            className="fmc-input"
            value={localAddress.email || ''}
            onChange={handleFieldChange}
          />
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="secondaryEmail">Secondary Email:</label>
        </td>
        <td>
          <input
            type="email"
            id="secondaryEmail"
            name="secondaryEmail"
            className="fmc-input"
            value={localAddress.secondaryEmail || ''}
            onChange={handleFieldChange}
          />
        </td>
      </tr>
    </>
  );
});

// Add prop validation
AddressComponent.propTypes = {
  addressData: PropTypes.shape({
    countryCd : PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};


export default AddressComponent;
